/**
 * Field thông số phòng (checkbox + stepper số lượng) trong form BĐS admin.
 */

/** Parse giá trị số lượng hợp lệ (> 0). */
const parseCount = (value) => {
  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : 0;
};

/**
 * Toggle và stepper cho một thông số phòng.
 * @param {Object} props
 * @param {string} props.label
 * @param {number|string} props.value
 * @param {Function} props.onChange
 * @param {string} [props.quantityLabel]
 */
export const RoomSpecField = ({ label, value, onChange, quantityLabel = 'Số lượng' }) => {
  const count = parseCount(value);
  const isEnabled = count > 0;

  const handleToggle = (event) => {
    onChange(event.target.checked ? 1 : '');
  };

  const handleDecrease = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (count <= 1) {
      onChange('');
      return;
    }

    onChange(count - 1);
  };

  const handleIncrease = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onChange(count + 1);
  };

  return (
    <label className={`room-spec-field ${isEnabled ? 'is-active' : ''}`.trim()}>
      <span className="room-spec-main">
        <input type="checkbox" checked={isEnabled} onChange={handleToggle} />
        <span className="room-spec-label">{label}</span>
      </span>

      {isEnabled && (
        <div
          className="room-spec-stepper"
          aria-label={quantityLabel}
          onMouseDown={(event) => event.preventDefault()}
        >
          <button
            type="button"
            className="room-spec-stepper-button"
            onClick={handleDecrease}
            aria-label={`Giảm ${label}`}
          >
            −
          </button>
          <span className="room-spec-stepper-value">{count}</span>
          <button
            type="button"
            className="room-spec-stepper-button"
            onClick={handleIncrease}
            aria-label={`Tăng ${label}`}
          >
            +
          </button>
        </div>
      )}
    </label>
  );
};
